module.exports = __webpack_public_path__ + "images/home/index/values-stage-bg-ccc5e9086f69b25b6f40d9218edf7fd4.png";